import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const PageContentContext = createContext(null);

export const usePageContentContext = () => {
    const context = useContext(PageContentContext);

    if (!context) {
        throw new Error("usePageContentContext must be used within an ContentProvider");
    }
    return context;
};

export const PageContentProvider = ({ children }) => {
    const pagesConfiguration = pagesConfigurationSetup;
    const [sideBarMenu, setSideBarMenu] = useState(null);
    const [withFilters, setWithFilters] = useState(null);
    const [currentPath, setCurrentPath] = useState('/home');

    useEffect(() => {
        const actualPageConfig = pagesConfiguration.filter((x) => x.path === currentPath);
        setSideBarMenu(actualPageConfig[0]?.subMenu);
        setWithFilters(actualPageConfig[0]?.filters);
    }, [currentPath]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const location = window.location.pathname;
            setCurrentPath(location);
        }
    }, [])

    const handlePagePathChange = (pathValue) => {
        setCurrentPath(pathValue);
    }

    const value = useMemo(() => {

        return {
            pagesConfiguration,
            sideBarMenu,
            withFilters,
            currentPath,
            handlePagePathChange
        };
    }, [pagesConfiguration, sideBarMenu, withFilters, currentPath]);

    return <PageContentContext.Provider value={value}>{children}</PageContentContext.Provider>
}

const pagesConfigurationSetup = [
    {
        tabName: "inicio",
        tabIcon: null,
        id: "home",
        path: "/home",
        subMenu: null,
        filters: false
    },
    {
        tabName: "map",
        tabIcon: null,
        id: "map",
        path: "/home/map",
        subMenu: null,
        filters: true
    },
    {
        tabName: "politicas",
        tabIcon: null,
        id: "policies",
        path: "/home/politics/CIRIS",
        filters: false
    },
    {
        tabName: "events",
        id: "events",
        path: "/home/events",
        subMenu: null,
        filters: true
    },
    {
        tabName: "registry",
        tabIcon: null,
        id: "registry",
        path: "/home/register",
        subMenu: null,
        filters: false
    },
    {
        tabName: "analytics",
        tabIcon: null,
        id: "analytics",
        path: "/home/analitics",
        filters: false
    },
    {
        tabName: "Configurations",
        id: "configurations",
        path: "/home/configurations/access",
        filters: false
    },
];